import axios from './request'
import { prop } from 'ramda'

/**
 * @typedef Status
 * @property {string} ID
 * @property {string} NAME
 * @property {boolean} HAS_MODAL
 * @property {boolean} HIDE_ON_DETAIL
 */

/**
 *
 * @returns {Promise<Status[]>}
 */
export default function getServiceRequestsStatuses() {
	return axios.get('/api/Other/getStatuses/')
		.then(({ data }) => data)
		.then(prop('data'))
}
